var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-provider',{scopedSlots:_vm._u([{key:"default",fn:function({ config, loading }){return [(!loading)?_c('markdown',{attrs:{"markdown-config":_vm.markdownConfig,"enable_beta_markdown_export":config.enable_beta_markdown_export,"export-link":_vm.exportUrl},on:{"onEdit":_vm.onEdit}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }